import React from 'react';

function EyeIcon(props: any) {
  return (
    <svg width="29" height="22" viewBox="0 0 29 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 11C3.27228 5.70229 8.4617 2 14.5 2C20.5383 2 25.7277 5.70229 28 11C25.7277 16.2977 20.5383 20 14.5 20C8.4617 20 3.27228 16.2977 1 11ZM20.5 11C20.5 14.3137 17.8137 17 14.5 17C11.1863 17 8.5 14.3137 8.5 11C8.5 7.68629 11.1863 5 14.5 5C15.4584 5 16.3643 5.22469 17.1679 5.62427C16.4575 6.1729 16 7.03302 16 8C16 9.65685 17.3431 11 19 11C19.5412 11 20.0489 10.8567 20.4873 10.606C20.4957 10.7362 20.5 10.8676 20.5 11Z"
        fill="#8B8EA9"
      />
      <path
        d="M17.5 11C17.5 12.6569 16.1569 14 14.5 14C12.8431 14 11.5 12.6569 11.5 11C11.5 9.34315 12.8431 8 14.5 8C16.1569 8 17.5 9.34315 17.5 11Z"
        fill="#8B8EA9"
      />
    </svg>
  );
}

export default EyeIcon;
